import { render, staticRenderFns } from "./LessonWords.vue?vue&type=template&id=2a3145f9&"
import script from "./LessonWords.vue?vue&type=script&lang=ts&"
export * from "./LessonWords.vue?vue&type=script&lang=ts&"
import style0 from "./LessonWords.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LessonWords.vue"
export default component.exports